<template>
  <component :is="activeComponent[accountType]" />
</template>

<script>
import { mapState } from 'vuex';
import * as ACCOUNT from '@/constants/accounts';

const Default = () => import('./Default');
// const Organization = () => import('./Organization');
// const Tournament = () => import('./Tournament');

export default {
  name: 'AccountCompetitions',
  computed: {
    ...mapState('current', ['accountType']),

    activeComponent() {
      return {
        [ACCOUNT.PROFILE]: Default,
        // [ACCOUNT.ORGANIZATION]: Organization,
        [ACCOUNT.CLAN]: Default,
        // [ACCOUNT.TOURNAMENT]: Tournament,
      };
    },
  },
};
</script>
